<template>
  <BundleSummaryCard class="border-green-400">
    <template #image>
      <img
        class="w-24 h-24"
        :src="assetUrl(MonthlyFIDImage)"
        alt="Monthly FID"
        width="600"
        height="600"
      >
    </template>
    <div
      v-if="tagLabel"
      class="flex-center w-fit rounded-full px-2 py-0.5 text-xs text-white bg-blue-500 mb-1"
    >
      {{ tagLabel }}
    </div>
    {{ $t('products.monthly_fid') }}
    <div
      class="text-green-500 font-medium text-sm"
      v-html="$t('products.free_monthly_with_your_subscription')"
    />

    <template #actions>
      <div class="free-badge">
        {{ $t('products.free') }}
      </div>
    </template>
  </BundleSummaryCard>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import BundleSummaryCard from './bundle-summary-card.vue'
import MonthlyFIDImage from '@/assets/images/fid-square.png'
import { assetUrl } from '@/utils'
import { usePidsStore } from '@/stores'

const store = usePidsStore()

const tagLabel = computed(() => store.fid?.protein_type)
</script>
